$.module('MM.ui.smscode', function () {
  var ACTIONS = {
    sendMobileNew: MM.core.getRoot(
      'authcode/new_send_mobile?mobile={mobile}&type={type}&china={china}&code=destsaz' +
        Math.floor(Math.random() * 100),
      'user',
    ),
    amberMobile: MM.core.getRoot('api/v2/verify_code/mobile_bind', 'amber'),
    bindBankMobile: MM.core.getRoot('api/v2/verify_code/bank_info', 'amber'), // 不需要极验证
    sendSmsCode: 'api/v2/verify_code/quick_login',
    completeMobileInfo:
      'user/complete_mobile_info?access_token={access_token}&china={china}&mobile={mobile}&sms_code={sms_code}',
    verifyCode: 'api/v2/verify_code',
  };

  var TMPL = {
    main: '\
        <div class="smscode-wrapper">\
            <% if(noMobileInput ) { %>\
                <div class="no-moblie-input ui-form-label" > <%= mobileText %> </div>\
                <input type="hidden" name="mobile" value="<%= mobile %>" />\
                <input type="hidden" name="fakeMobile" value="<%= mobile %>" />\
            <% } else { %>\
                <div class="ui-form-item sms-mobile-item <%= global ? "has-global" : "" %>">\
                    <% if(global) { %>\
                        <div class="smscode-phone-prefix">\
                            <div class="phone-prefix" data-prefix="0"> +86 </div>\
                            <div class="phone-prefix-list  ui-hide">\
                            <ul>\
                                <% for(var i = 0 ; i < phonePrefix.length; i++) { var item = phonePrefix[i] || {};  %>\
                                    <li class="fix" >\
                                        <span class="smscode-country fl"><%= item.country %></span>\
                                        <span class="smscode-prefixcode fr" data-prefix="<%= i %>">+<%= item.prefixcode %></span>\
                                    </li>\
                                <% } %>\
                            </ul>\
                            </div>\
                        </div>\
                    <% } %>\
                    <input class="ui-form-input mobile-input" name="fakeMobile" value="<%= fakeMobile %>" type="number" min="1" placeholder="请输入手机号" />\
                    <input type="hidden" name="mobile" value="<%= mobile %>" />\
                </div>\
            <% } %>\
            <div class="ui-form-item fix">\
                <input class="inline ui-form-input code-input fl"  autocomplete="off"  name="sms_code" type="text" placeholder="请输入短信验证码" />\
                <div class="inline btn btn-large ui-form-btn smscode-code-btn">发送验证码</div>\
            </div>\
        </div>\
        ',

    safeCheck:
      '\
        <div class="smscode-wrapper">\
            <div class="ui-form-item sms-mobile-item safe-item safe-item-margin">\
            <div class="smscode-phone-prefix">\
                <div class="phone-prefix" data-prefix="0"> +86 </div>\
                <div class="phone-prefix-list ui-hide">\
                    <ul>\
                        <% for(var i = 0 ; i < phonePrefix.length; i++) { var item = phonePrefix[i] || {};  %>\
                            <li class="fix" >\
                                <span class="smscode-country fl"><%= item.country %></span>\
                                <span class="smscode-prefixcode fr" data-prefix="<%= i %>">+<%= item.prefixcode %></span>\
                            </li>\
                        <% } %>\
                    </ul>\
                </div>\
            </div>\
            <div class="extra-form-mobile"></div>\
            </div>\
                <div class="ui-form-item safe-item-margin fix">\
                    <input class="inline ui-form-input code-input fl"  autocomplete="off"  name="sms_code" type="text" placeholder="请输入短信验证码" />\
                    <i class="iconfont icon-guanbi1 clear-code"></i>\
                <div class="inline btn btn-large ui-form-btn smscode-code-btn">发送验证码</div>\
            </div>\
            <div class="ui-form-item-submit"><p class="ui-form-btn btn-login">登&nbsp;&nbsp;录</p></div>\
        </div>\
        ',
  };

  // <input name="code" type="hidden" />\

  var MSG_ERRORS = {
    30412: '余额不足',
    30432: '手机号格式错误',
    30419: '发送短信需填写验证码',
    30431: '短信验证码无效',
    30433: '手机号码已绑定',
    30435: '短信验证间隔太短',
    30437: '短信验证码每日次数超过限制',
    30250: '这是一个bug，反正我是信了', //测试主播改密码

    4018: '手机号格式错误',
  };

  var CHINA_PREFIX = {
    country: '中国',
    prefixcode: 86,
    length: 11,
  };

  var GLOBAL_PHONE_PREFIX = $.store.get('GLOBAL_PHONE_PREFIX') || [];
  var $wrapper;
  var $errorTip;
  var $codeBtn;
  var _timer = null;
  var _prefix = null;
  var _options = null;

  function _initPhonePrefix(callback) {
    MM.util.flint.getField(
      'meme/app_public',
      'telephone_prefix_code.list',
      function (data) {
        GLOBAL_PHONE_PREFIX = data || [];
        $.store.set('GLOBAL_PHONE_PREFIX', GLOBAL_PHONE_PREFIX);
        callback && callback();
      },
    );
  }

  function _init() {
    $wrapper = $(_options.$wrapper);
    $errorTip = $(_options.$errorTip);
    _prefix = CHINA_PREFIX;

    if (_options.typeObject === 'safeCheck') {
      $($wrapper).html($.template(TMPL.safeCheck, _options));
    } else {
      $($wrapper).html($.template(TMPL.main, _options));
    }

    $codeBtn = $wrapper.find('.smscode-code-btn');
    _options.appendCallback && _options.appendCallback($wrapper);

    _bindEvent();

    $wrapper
      .find('.extra-form-mobile')
      .text(getPhoneMask(_options.tokenInfo.en_mobile));

    // $(".phone-prefix-list").nanoScroller();

    if (_timer) {
      // 清空定时器
      _timer = clearInterval(_timer);
      _timer = null;
    }
  }

  function _getOptionByType(actionType) {
    switch (actionType) {
      case 'bindBankMobile':
        return {
          apiVer: 2,
          contentType: 'JSON',
          noGeetCheck: true,
          requestType: 'POST',
        };
    }
    return {};
  }

  function _render(options) {
    _options = _.assign(
      {},
      {
        mobileText: '',
        mobile: '',
        fakeMobile: '',
        phonePrefix: GLOBAL_PHONE_PREFIX,
        global: true,
        noMobileInput: false,
        type: 1,
        saText: '', // 发送手机号 上报数据 文本
        $submitBtn: '', // 提交 按钮 复杂验证时使用
        checkRepeat: false, // 是否校验已经绑定过手机号
        onSubmit: null, // 验证提交按钮
        action: '', // 提交请求的接口
        actionType: 'sendMobileNew', // 提交请求的接口类型
        requestType: 'GET', // 提交请求的方法
        geetKey: 'bindmobile', // 极验证 key 有效减少 极验证实例
        noGeetCheck: false, // 关闭极验证 直接请求
        apiVer: 1, // API 版本号
        tokenInfo: {}, // 安全验证信息
      },
      _getOptionByType(options.actionType),
      options,
    );
    // GLOBAL_PHONE_PREFIX 不存在时 需要获取 前缀数据
    if (_options.global && !_options.phonePrefix.length) {
      _initPhonePrefix(function () {
        _options.phonePrefix = GLOBAL_PHONE_PREFIX;
        _init();
      });
      return;
    }

    _init();
  }

  function _sendMobileCode(data) {
    var reqOpt = {
      disableCommonErrorHandler: true,
      url:
        _options.action ||
        ACTIONS[_options.actionType] ||
        ACTIONS.sendMobileNew,
      type: _options.requestType,
      data: data,
      success: function (res) {
        sa.track('message_sent', {
          type: data.saText,
        });
        _btnCountDown();
      },
      error: function (res) {
        $errorTip.text(MSG_ERRORS[res.code] || res.message || '发送验证码失败');
      },
    };
    // 需要 JSON 方式提交
    if (_options.contentType === 'JSON') {
      reqOpt.contentType = 'JSON';
    }

    if (_options.noGeetCheck) {
      return request.send(reqOpt);
    }

    MM.common.geetestRquest(data.geetKey, reqOpt);
  }

  function _verifySmsCode() {
    var data = {
      nation_code: '+' + _prefix.prefixcode,
      mobile: _options.tokenInfo.en_mobile,
    };
    var reqOpt = {
      disableCommonErrorHandler: true,
      url: ACTIONS.sendSmsCode,
      urlType: 'amber',
      type: 'POST',
      data: data,
      success: function (res) {
        _btnCountDown();
      },
      error: function (res) {
        $errorTip.text(MSG_ERRORS[res.code] || res.message || '发送验证码失败');
      },
    };
    // 需要 JSON 方式提交
    reqOpt.contentType = 'JSON';

    if (_options.noGeetCheck) {
      return request.send(reqOpt);
    }

    MM.common.geetestRquest(data.geetKey, reqOpt);
  }

  function _btnCountDown() {
    var time = 60;

    $codeBtn.addClass('btn-disabled').text(time + 's后重发');
    clearInterval(_timer);
    _timer = setInterval(function () {
      $codeBtn.text(--time + 's后重发');

      if (time === 0) {
        $codeBtn.removeClass('btn-disabled').text('发送验证码');
        clearInterval(_timer);
        _timer = null;
      }
    }, 1000);
  }

  function _checkData(checkCode, callback) {
    var $mobile = $wrapper.find('input[name="mobile"]');
    var source = $.serializeForm($wrapper);
    var length = parseInt(_prefix.length, 10);
    $errorTip.text('');

    if (!source.fakeMobile || (length && source.fakeMobile.length !== length)) {
      return $errorTip.text('请输入正确的手机号');
    } else if (checkCode && _.trim(source.sms_code) === '') {
      return $errorTip.text('请输入验证码');
    }

    // 新版版 API 参数
    if (_options.apiVer === 2) {
      source.nation_code = _prefix.prefixcode;

      // 老版 API 参数
    } else if (_options.apiVer === 1) {
      if (_prefix.country === '中国') {
        source.mobile = source.fakeMobile;
      } else {
        source.mobile = _prefix.prefixcode + source.fakeMobile;
      }

      // 是否 是中国号码 简单验证
      source.china = source.mobile.length === 11 && source.mobile[0] == '1';

      // 同步 UI 视图 moblie数据
      $mobile.val(source.mobile);
    }

    // 不校验 重复绑定
    if (!_options.checkRepeat) {
      callback && callback(source);
      return;
    }

    // 校验 重复绑定
    MM.user.checkMobileRepeat(
      source.mobile,
      function () {
        callback && callback(source);
      },
      function () {
        $errorTip.text('该手机号已绑定其他么么号，请更换手机号');
      },
    );
  }

  function _bindEvent() {
    var $phonePrefixList = $wrapper.find('.phone-prefix-list');
    var $submitBtn = _options.$submitBtn;

    $wrapper
      .on('click', '.phone-prefix', function () {
        $phonePrefixList.toggleClass('ui-hide');
      })
      .on('mouseleave', '.phone-prefix-list', function () {
        $phonePrefixList.addClass('ui-hide');
      })
      .on('click', '.phone-prefix-list li', function () {
        var $prefix = $(this).find('.smscode-prefixcode');
        _prefix = GLOBAL_PHONE_PREFIX[$prefix.data('prefix')] || CHINA_PREFIX;
        $wrapper.find('.phone-prefix').text('+' + _prefix.prefixcode);
        $phonePrefixList.addClass('ui-hide');
      })
      .on('focus', 'input', function () {
        // 去除校验信息
        $errorTip.text('');
        $phonePrefixList.addClass('ui-hide');
      })
      .on('blur', 'input', function () {
        // 添加校验信息
        var $this = $(this);
        var name = $this.attr('name');

        if (name === 'sms_code') {
          $this.siblings('input').val($this.val());
          return;
        }

        if (name === 'mobile') {
          var mobile = $this.val();
          var length = parseInt(_prefix.length, 10);
          if (!mobile.length || (length && mobile.length !== length)) {
            return $errorTip.text('请输入正确的手机号');
          }

          if (_prefix.country !== '中国') {
            mobile = _prefix.prefixcode + mobile;
          }

          if (_options.checkRepeat) {
            MM.user.checkMobileRepeat(mobile, null, function () {
              $errorTip.text('该手机号已绑定其他么么号，请更换手机号');
            });
          }
        }
      })
      .on('click', '.smscode-code-btn', function () {
        // 发送验证码按钮
        if ($(this).hasClass('btn-disabled')) return;
        if (_options.typeObject === 'safeCheck') {
          return _verifySmsCode(_options);
        }
        _checkData(false, function (source) {
          var data = _.assign(_.pick(_options, ['type', 'saText']), source);
          _sendMobileCode(data);
        });
      })
      .on('click', '.btn-login', function () {
        _completeMobileInfo();
      })
      .on('keyup', 'input', function (e) {
        if (e.keyCode !== 13) return;
        if (_options.typeObject === 'safeCheck') {
          _completeMobileInfo();
        }
      });

    if ($submitBtn && _options.onSubmit) {
      $($submitBtn).on('click', function () {
        _checkData(true, function (source) {
          _options.onSubmit(source);
        });
      });
    }
  }

  function _completeMobileInfo() {
    var source = $.serializeForm($wrapper);

    $errorTip.text('');
    if (!source.sms_code) {
      return $errorTip.text('请填写验证码');
    }

    var _loginCallback =
      typeof success == 'function'
        ? success
        : function () {
            if ($.query.get('referrer')) {
              location.href = $.query.get('referrer');
            } else {
              location.reload();
            }
          };

    var data = {
      mobile: _options.tokenInfo.en_mobile,
      sms_code: source.sms_code,
      sms_type: 'mobile_login',
    };

    var reqOpt = {
      disableCommonErrorHandler: true,
      url: ACTIONS.verifyCode,
      type: 'POST',
      urlType: 'amber',
      data: data,
      contentType: 'JSON',
      success: function (res) {
        MM.user.refreshToken.save(_options.tokenInfo);

        MM.log.send({
          event: 'user',
          event_type: 'meme_login',
        });

        MM.user.getExtraUserInfo(function () {
          MM.log.send({
            event: 'user',
            event_type: 'login_success',
          });

          location.reload();
          // location.reload();
        });
      },
      error: function (res) {
        $errorTip.text(MSG_ERRORS[res.code] || res.message || '验证失败');
      },
    };
    return request.send(reqOpt);
  }

  function getPhoneMask(phone) {
    if (!phone) {
      return '';
    }
    phone = phone + '';
    var arr = phone.split('');
    arr.splice(3, 4, ' **** ');
    return arr.join('');
  }

  return {
    render: _render,
  };
});
